import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
import { EProvisioning } from './user';
export let EFollowupWorkflowGalleryStatus; // rejected for publication
(function (EFollowupWorkflowGalleryStatus) {
  EFollowupWorkflowGalleryStatus["Pending"] = "pending";
  EFollowupWorkflowGalleryStatus["Published"] = "published";
  EFollowupWorkflowGalleryStatus["Rejected"] = "rejected";
})(EFollowupWorkflowGalleryStatus || (EFollowupWorkflowGalleryStatus = {}));
export let EFollowupWorkflowGalleryCategory;
(function (EFollowupWorkflowGalleryCategory) {
  EFollowupWorkflowGalleryCategory["Access"] = "access";
  EFollowupWorkflowGalleryCategory["Communication"] = "communication";
  EFollowupWorkflowGalleryCategory["Financial"] = "financial";
  EFollowupWorkflowGalleryCategory["Administration"] = "administration";
})(EFollowupWorkflowGalleryCategory || (EFollowupWorkflowGalleryCategory = {}));
export const fieldsFollowupWorkflowGallery = _extends({}, fieldsIBaseModel, {
  artwork: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  bedrock: {
    type: 'Boolean'
  },
  category: {
    type: 'Option',
    values: EFollowupWorkflowGalleryCategory
  },
  description: {
    type: 'Text'
  },
  name: {
    type: 'Text'
  },
  provisioning: {
    type: 'Option',
    values: EProvisioning,
    array: true
  },
  publishedFrom: {
    type: 'ID',
    ref: EModel.FollowupWorkflow
  },
  status: {
    type: 'Option',
    values: EFollowupWorkflowGalleryStatus
  },
  versions: {
    type: 'Object',
    array: true
  }
});